import { action } from "@ember/object"
import { inject } from "@ember/service"
import Component from "@glimmer/component"
import type { Course } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"
import type { RotationCalendar } from "@shared/models/rotation-calendar"
import type RotationEditor from "cc-frontend/services/rotation-editor"
import { find } from "lodash-es"

interface Args {
  courses: Array<Course>
  planbook: Planbook
  rotationCalendar: RotationCalendar
  rotationCycleResetsOnDay: boolean
  dateString: string
  closeMenu: Function
}

export default class ChangeRotationComponent extends Component<Args> {
  @inject rotationEditor!: RotationEditor
  @inject notifier

  @action changeRotation(newRotationId: string) {
    this.rotationEditor.changeRotationIdOnDay({
      dateString: this.args.dateString,
      rotationCalendar: this.args.rotationCalendar,
      courses: this.args.courses,
      planbook: this.args.planbook,
      newRotationId: newRotationId,
    })
    this.args.closeMenu()
    let formattedDate = dateFns.format(dateFns.parse(this.args.dateString), "MMM Do, YYYY")
    let rotation = find(
      this.args.rotationCalendar.attributes.rotations,
      (r) => r.id === newRotationId
    )
    this.notifier.success("", {
      title: `${formattedDate} was changed to a ${rotation?.title}`,
      message: "Click the Undo Button to undo this.",
      duration: 5000,
    })
  }
}
